export enum FiltersName {
  Municipio = 'municipio',
  Provincia = 'provincia',
  CodVia = 'codigovia',
  NombreVia = 'nombrevia'
}